import { type ReactElement, useEffect, useRef } from 'react';
import { type Image } from '../Types';
import { Lazyloader } from '../commonComponents';

interface YouTubeVideoProps {
    referrer: string;
    videoId: string;
    previewImage?: Image;
    title?: string;
}

declare const Cookiebot: {
    renew: () => void;
};

function YouTubeVideo({ previewImage, referrer, title, videoId }: YouTubeVideoProps): ReactElement {
    // Super hack to fix server/client mismatch casued by cookiebot
    const iframeRef = useRef<HTMLIFrameElement>();
    useEffect(() => {
        iframeRef.current.className = ' ' + iframeRef.current.className;
    }, []);

    return (
        <figure className="ratio ratio-16x9">
            <iframe
                data-src={`//www.youtube-nocookie.com/embed/${videoId.trim()}?rel=0&origin=${referrer}`}
                title={`Inbäddat YouTube-klipp: ${title}`}
                ref={iframeRef}
                className="cookieconsent-optin-marketing"
                data-cookieconsent="marketing"
                allowFullScreen={true}
            />
            <div className="cookieconsent-optout-marketing marketing-video-consent__image">
                {previewImage && <Lazyloader image={previewImage} hasVideo={true} />}
            </div>
            <div className="backdrop cookieconsent-optout-marketing marketing-video-consent__text-container">
                <div className="marketing-video-consent__text">
                    <button
                        className="unstyled-button"
                        onClick={() => {
                            Cookiebot.renew();
                        }}
                    >
                        Godkänn marknadsföringskakor
                    </button>{' '}
                    för att titta på detta klipp.
                </div>
            </div>
        </figure>
    );
}

export { YouTubeVideo };
